import { UPDATE_CHAT_STATUS } from '@/store/mutation-types';

const mutations = {
  [UPDATE_CHAT_STATUS](state, newStatus) {
    state.channels.chat.status = newStatus;
  },
};

export default mutations;
